<button class="btn btn-dark" style="border-radius: 1rem; color: #fff; background-color: rgb(18, 25, 122);" type="button" disabled>
    Estas usando una versión del sistema desactualizada, por favor presione CTRL + F5 para continuar...
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    
  </button>